<script setup lang="ts"></script>

<template>
  <icon name="lucide:text-cursor" />
</template>

<style scoped></style>
